import React from 'react';
import './curve-theme.css';

export type StatusTabItem = {
  id: 'all' | 'pending' | 'in_progress' | 'closed';
  label: string;
  count: number;
};

type StatusTabsProps = {
  items: StatusTabItem[];
  activeId: StatusTabItem['id'];
  onSelect: (id: StatusTabItem['id']) => void;
};

export function StatusTabs({ items, activeId, onSelect }: StatusTabsProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        borderBottom: '1px solid var(--curve-border, #E5E5E5)',
        background: 'var(--curve-bg-white, #FFFFFF)',
        padding: '0 8px',
        overflowX: 'auto',
        scrollbarWidth: 'none',
      }}
    >
      {items.map((item) => {
        const isActive = item.id === activeId;
        return (
          <button
            key={item.id}
            onClick={() => onSelect(item.id)}
            className="curve-btn"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              padding: '8px 10px',
              borderBottom: isActive
                ? '2px solid var(--curve-primary, #22C55E)'
                : '2px solid transparent',
              fontSize: 'var(--curve-text-small, 13px)',
              fontWeight: isActive ? 600 : 400,
              color: isActive
                ? 'var(--curve-primary, #22C55E)'
                : 'var(--curve-text-muted, #64748B)',
              transition: 'color var(--curve-transition), border-bottom-color var(--curve-transition)',
              whiteSpace: 'nowrap',
              marginBottom: '-1px',
              borderLeft: 'none',
              borderRight: 'none',
              borderTop: 'none',
              background: 'transparent',
            }}
            onMouseEnter={(e) => {
              if (!isActive)
                (e.currentTarget as HTMLButtonElement).style.color =
                  'var(--curve-text-dark, #1E293B)';
            }}
            onMouseLeave={(e) => {
              if (!isActive)
                (e.currentTarget as HTMLButtonElement).style.color =
                  'var(--curve-text-muted, #64748B)';
            }}
          >
            {item.label}
            {item.count > 0 && (
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minWidth: '18px',
                  height: '18px',
                  borderRadius: 'var(--curve-radius-pill, 9999px)',
                  background: isActive
                    ? 'var(--curve-primary, #22C55E)'
                    : 'var(--curve-border, #E5E5E5)',
                  color: isActive ? 'var(--curve-text-on-primary, #FFFFFF)' : 'var(--curve-text-muted, #64748B)',
                  fontSize: 'var(--curve-text-xxs, 11px)',
                  fontWeight: 600,
                  padding: '0 4px',
                  lineHeight: 1,
                }}
              >
                {item.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
